import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import {store} from './store'
import {http} from './axios/HTTP'
import { BASE_DOMAIN } from './domain'
import Maska from 'maska'
import 'vue2-datepicker/index.css'

import YandexMetrika from './plugins/yandexMetrika'
Vue.use(YandexMetrika)

Vue.prototype.$http = new http(store)
Vue.prototype.$baseDomain = BASE_DOMAIN
Vue.use(Maska)
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App),
  store
}).$mount('#app')